import { render, staticRenderFns } from "./DanutChart.vue?vue&type=template&id=9d8f549e&scoped=true"
import script from "./DanutChart.vue?vue&type=script&lang=js"
export * from "./DanutChart.vue?vue&type=script&lang=js"
import style0 from "./DanutChart.vue?vue&type=style&index=0&id=9d8f549e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8f549e",
  null
  
)

export default component.exports